(() => {
  const init = () => {
    document.querySelectorAll('.pmw-document-content .rte table').forEach(table => {
      if (table.parentElement.classList.contains('pmw-document-table')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'pmw-document-table';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || 'Tabela — przewiń w poziomie');
      table.before(wrapper);
      wrapper.append(table);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
